<template>
  <div>
    <div class="pc_main">
      <div class="commons">
        <img
          style="filter: contrast(0.8) brightness(0.8);"
          src="../../../assets/image/banner1.png"
          alt="共享单车锁"
        />
        <h1>
          智慧产品
          <span class="span_hid"></span>
        </h1>
      </div>
      <section class="pc_product">
        <ul class="pc_product_wrap">
          <li v-for="(list,index) in list" :key="index" class="clearfix" >
            <div class="header">
              <p class="line"></p>
              <h3
                :id="list.name" :name="list.name" :ref="list.name"
              >{{list.title}}</h3>
              <div v-if="list.level" class="level-wrapper">
                <p class="line" style="background:#00a0e9;margin-top:0.2rem;height: 0.24rem;"></p>
                <h4>{{list.level}}</h4>
              </div>
            </div>
            <div class="product-detail">
              <p>{{list.desc}}</p>
            </div>
            <div v-for="item in list.content" :key="item.id" id="lock" @click="hinditem(item.id)">
              <div class="lock-wrapper" :style="{justifyContent:item.name=='XV100'?'flex-end':''}">
                <img :src="item.pc_img" alt="" />
              </div>
              <div class="lock-box">
                <p>{{item.name}}</p>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="mobile_main">
      <section>
        <div class="m-commons">
          <img src="../../../assets/mobileImg/m-trans.png" alt="智慧产品" />
          <h1>
            智慧产品
            <span class="m-span_hid"></span>
          </h1>
        </div>
      </section>
      <section class="scroll_menu">
        <span @click="showMenu">
          智慧产品
          <i class="iconfont icon-jiantou"></i>
        </span>
        <span>{{selectName}}</span>
        <ul class="selectMenu" v-show="menuShow">
          <li>
            <router-link to="Transportation">
              <span>智慧出行</span>
              <div class="trans_icon" @click.prevent="selectchange">
                <i :class="selectBox ? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
              </div>
            </router-link>
            <div v-if="selectBox">
              <a href="/smartProduct/Transportation?#Product-Travel" class="box_ele">交通出行</a>
              <a href="/smartProduct/Transportation?#Product-car" class="box_ele">车联网</a>
            </div>
          </li>
          <li>
            <router-link to="Interspace">智慧空间</router-link>
          </li>
          <li>
            <router-link to="logistics">智慧物流</router-link>
          </li>
          <li>
            <router-link to="Retail">
              <span>智慧零售</span>
              <div class="trans_icon" @click.prevent="selectClick">
                <i :class="changeBox ? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
              </div>
            </router-link>
            <div v-if="changeBox">
              <a href="/smartProduct/Retail?#product-retail" class="box_ele">无人零售货柜</a>
              <a href="/smartProduct/Retail?#product-super" class="box_ele">商超购物车智能锁</a>
            </div>
          </li>
          <li>
            <router-link to="cartronics">
              <span>汽车电子</span>
              <div class="trans_icon" @click.prevent="Clickbox">
                <i :class="clickBox ? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
              </div>
            </router-link>
            <div v-if="clickBox">
              <a href="/smartProduct/cartronics?#Product-gasoline" class="box_ele">汽油车智能诊断</a>
              <a href="/smartProduct/cartronics?#Product-diesel" class="box_ele">柴油车智能诊断</a>
              <a href="/smartProduct/cartronics?#Product-locksmith" class="box_ele">锁匠系列</a>
              <a href="/smartProduct/cartronics?#Product-tire" class="box_ele">胎压诊断系列</a>
              <a href="/smartProduct/cartronics?#Product-other" class="box_ele">其他诊断及配件</a>
            </div>
          </li>
        </ul>
      </section>
      <section>
        <ul class="m-trans_box">
          <li v-for="(item,index) in list" :key="index" class="m-trans_child">
            <div class="m-header">
              <h3 :id="item.path" :name="item.path" :ref="item.path">{{item.title}}</h3>
              <p></p>
            </div>
            <div class="m-trans_desc">{{item.desc}}</div>
            <ol class="m-trans_content" v-if="selectName !='汽车电子'">
              <template v-for="list in item.content">
                <li :key="list.id" class="m-trans_item">
                  <h3>{{list.name}}</h3>
                  <div class="m-trans_imtex">
                    <img :src="list.img" alt="智慧产品" />
                    <p @click="hinditem(list.id)">
                      了解更多
                      <img src="../../../assets/mobileImg/lan.png" alt="智慧产品" />
                    </p>
                  </div>
                </li>
              </template>
            </ol>
            <div v-else class="m-cart_wrapper">
              <swiper :options="cartSwiper" class="m-swiper_wrapper">
                <template v-for="list in item.content">
                  <swiper-slide :key="list.name" class="m-slide_wrapper">
                    <div class="m-cart_box">
                    <div class="m-cartimg-box" :style="{justifyContent:list.name=='XV100'?'flex-end':''}">
                       <div :style="{width:list.width,height:list.height}">
                        <img :src="list.img" alt="智慧产品" />
                     </div>
                    </div>
                      <h4>{{list.name}}</h4>
                    </div>
                  </swiper-slide>
                </template>
              </swiper>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    selectName: {
      type: String
    }
  },
  data() {
    return {
      menuShow: false,
      selectBox: false,
      changeBox: false,
      clickBox:false,
      cartSwiper:{
        slidesPerView: 'auto', //分为几块
        spaceBetween: 10, //二者之间间距
        centerInsufficientSlides: true,
      }
    };
  },
  methods: {
    hinditem(id) {
      this.$emit("binditem", id);
    },
    showMenu() {
      this.menuShow = !this.menuShow;
    },
    selectchange() {
      this.selectBox = !this.selectBox;
    },
    selectClick() {
      this.changeBox = !this.changeBox;
    },
    Clickbox(){
      this.clickBox = !this.clickBox;
    }
  }
};
</script>
<style lang="scss" scoped>
//PC端
.pc_product {
  width: 100%;
  background: rgba(249, 251, 253, 1);
  .pc_product_wrap {
    width: 87%;
    padding-top: 0.71rem;
    box-sizing: border-box;
    margin: auto;
    li {
      width: 100%;
      margin-bottom: 1.6rem;
      .header {
        overflow: hidden;
        .line {
          width: 0.04rem;
          height: 0.3rem;
          background: rgba(1, 52, 137, 1);
          float: left;
          margin-right: 0.24rem;
        }
        h3{
          font-size: 0.3rem;
          font-weight: 600;
          color:#000;
          height: 0.5rem;
        }
        h4 {
          font-weight: 600;
          float: left;
          height: 0.5rem;
          margin-top:0.2rem;
          font-size: 0.24rem;
          color:#999;
        }
      }
      .product-detail {
        margin-top: 0.79rem;
        p {
          font-size: 0.22rem;
          color: rgb(115, 118, 112);
          line-height: 0.48rem;
        }
      }
      #lock {
        width: 3.4rem;
        border: 0.01rem solid rgba(234, 234, 234, 1);
        background: #fff;
        overflow: hidden;
        text-align: center;
        float: left;
        margin-top: .6rem;
        cursor: pointer;
        margin-right: 0.41rem;
        .lock-wrapper{
          width: 100%;
          height: 1.72rem;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 2.7rem;
            max-height: 1.68rem;
            transition: all 0.5s;
          }
        }
        .lock-box {
          width: 3.4rem;
          height: 1.58rem;
          border: 0.01rem solid rgba(234, 234, 234, 1);
          background: rgba(249, 251, 253, 1);
          line-height: 1.58rem;
          p {
            font-size: 0.3rem;
            font-weight: 500;
            color: rgba(64, 66, 68, 1);
          }
        }
        &:hover {
          img {
            -webkit-transform: scale(1.05);
            -moz-transform: scale(1.05);
            -ms-transform: scale(1.05);
            -o-transform: scale(1.05);
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
  .clearfix:after,.clearfix:before{
        content: "";
        display: table;
    }
    .clearfix:after{
        clear: both;
    }
    .clearfix{
        *zoom: 1;
    }
//移动端
.scroll_menu {
  display: flex;
  width: 100%;
  padding: 0 5px;
  height: 40px;
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  color: rgba(9, 130, 214, 1);
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-bottom: 1px solid rgba(216, 216, 216, 1);
  position: relative;
  > span {
    &:nth-child(2) {
      color: rgba(0, 0, 0, 1);
      margin: 0 5px;
    }
    i {
      color: #d8d8d8;
    }
  }
  .selectMenu {
    position: absolute;
    top: 40px;
    left: 0;
    font-size: 15px;
    width: 50%;
    background: #fff;
    padding: 0 10px 20px 10px;
    box-sizing: border-box;
    box-shadow: 0 0 10px #ccc;
    z-index: 10;
    transition: all 0.3s ease-in-out;
    li {
      position: relative;
      a {
        color: rgba(139, 139, 139, 1);
        display: block;
        height: 35px;
        line-height: 35px;
        position: relative;
        padding-right: 20px;
        .trans_icon {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 80px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 10px;
          i {
            color: rgba(139, 139, 139, 1);
            padding-left: 36%;
          }
        }
      }
      .box_ele {
        line-height: 35px;
        display: block;
        font-size: 15px;
        color: rgba(139, 139, 139, 1);
        letter-spacing: 0;
        padding-left: 20px;
      }
    }
  }
}
.m-trans_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  .m-trans_child {
    margin-top: 15px;
    width: 100%;
    .m-trans_desc {
      margin-top: 18px;
      font-size: 12px;
      line-height: 25px;
      color: rgba(0, 0, 0, 1);
      text-align: center;
      width: 100%;
      padding: 0 13px;
      box-sizing: border-box;
    }
    .m-trans_content {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: 25px;
      .m-trans_item {
        width: 100%;
        height: 240px;
        position: relative;
        border-bottom: 1px solid rgba(216, 216, 216, 1);
        border-top: 1px solid rgba(216, 216, 216, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 15px auto;
        opacity: 1;
        h3 {
          position: absolute;
          font-size: 15px;
          line-height: 21px;
          color: rgba(0, 0, 0, 1);
          top: 18px;
          left: 15px;
        }
        .m-trans_imtex {
          display: flex;
          flex-direction: column;
          margin: 10px 0 0 10px;
          img {
            display: block;
            margin-left: 10px;
          }
          p {
            font-size: 14px;
            font-weight: 500;
            color: #0982d6;
            margin: auto;
            display: flex;
            border: 1px solid rgba(9, 130, 214, 1);
            border-radius: 21px;
            padding: 8px 15px;
            margin-top: 10px;
            box-sizing: border-box;
            img {
              margin-left: 5px;
              width: 12px;
              height: 15px;
            }
          }
        }
      }
    }
    .m-cart_wrapper{
      width: 100%;
      padding: 30px 13px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(242,242,242,1);
      .m-swiper_wrapper{
        touch-action: none;
        width: 100%;
        .m-slide_wrapper{
          width: 160px;
          .m-cart_box{
            width: 100%;
            border: 1px solid #eee;
           .m-cartimg-box{
             width: 100%;
             height: 100px;
             display: flex;
             justify-content: center;
             align-items: center;
             background: #F2F2F2;
             img{
               width: 100%;
               height: 100%;
               display: block;
             }
           }
            h4{
              width: 100%;
              height: 40px;
              line-height: 40px;
              font-size: 15px;
              color: rgba(0, 0, 0, 1);
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/smartProduct/components/template.vue